import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PublicSharedService } from './public-shared.services';
import { PublicSharedLiveService } from './public-shared-live.services';
import * as _ from "lodash";
import * as moment from 'moment';
import { DialogOKComponent } from '../shared/modals/dialog-ok.component';
import { NbDialogService } from '@nebular/theme';
import {WebRTCAdaptor} from "../../../assets/js/antmedia/webrtc_adaptor.js";
import { EnvironmentSpecificService } from "../../environment-specific.service";

declare var getUrlVars;
declare var $: any;
declare var document:any;
declare var closeFullscreen: any;
@Component({
  selector: 'shared-live-view.component',
  templateUrl: './shared-live-view.component.html',
  styleUrls: ['./shared-live-view.component.scss']
})
export class SharedLiveView implements OnInit ,OnDestroy {
  loading: boolean = false;
  loadingMessage: string = 'Loading live stream…';
  token: string;
  streamToken: string;
  deviceId: string;
  data: any;
  videodemo: string = "";
  videoTimeout = 720;
  submitted: boolean = false;
  localVideos:Array<string> = [];
  remoteVideos:Array<string> = [];
  userId: string;
  requirePassword: boolean = false;
  isSharedDataAvaliableBox: boolean = false;
  isSharedExpired: boolean = false;
  isOffline: boolean = false;
  expiryDate: Date;
  isError: boolean = false;
  isExceeded: boolean = false;
  isStreamError: boolean = false;
  isDisconnected: boolean = false;
  isReady: boolean = false;
  title: string = 'QUICKTEL SHARED LIVE VIEW';
  isStart: boolean  = false;
  messages: any =  {
    no_data: "Unable locate the shared live view data. The link may be invalid or no longer available.",
    expired:"Access denied! Shared live view link has expired on",
    error:"Unable to retrieve shared live view! An unexpected error has occurred.",
    is_offline: "Device is offline.",
    stream_limit: "Streaming limit exceeded. Please try again later or upgrade your plan.",
    stream_error: "Cannot start live stream.",
    stream_exceeded: "Streaming limit exceeded. Please try again later or upgrade your plan.",
    device_disconnected:"Live stream stopped. Refresh the page to start a new session."
  }
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private publicSharedService: PublicSharedService,
    private publicSharedLiveService: PublicSharedLiveService,
    private dialogService: NbDialogService,
    private _envService: EnvironmentSpecificService,
    private _toastr: ToastrService
  ) { 
  }

    ngOnInit(): void {
     
      this.activatedRoute.queryParams.subscribe(params => {
          this.token = encodeURIComponent(params['token']);
          this.publicSharedService.GetSharedLiveView(this.token,this.publicSharedService.passwordForm).subscribe(res => {
            this.LoadData(res);
          });
      });
    }

    ngOnDestroy(){
      this.onStop();
    }


    LoadData(res){
      if(res.status){
        this.loading = true;
        this.loadingMessage = "Loading live stream…";
        this.streamToken = res.data.token;
        this.userId = res.data.user;
        this.deviceId = res.data.device;
          this.publicSharedLiveService.SocketConnect(this.streamToken);
          this.publicSharedLiveService.GetResponseStream().subscribe(res => {
            if(res.type == 'connect') {
              if(!this.isStart){
                this.publicSharedLiveService.IsDeviceOnline();
              }
            }
            if(res.type == 'livedeviceoffline' || res.type == 'livedevicerecordingstop') {
              if(res.data.userId == this.deviceId){
                  if(!this.isError){
                    this.loading = false;
                    this.onStop();
                  }
              }
            }
            if(res.type == 'ResponseStartStreamByAnonymous') {
              if(res.data.status){
                this.onResponseStream(res);
              }else{
                this.loading = false;
                this.isError = true;
                this.isStreamError = true;
              }
            }else if(res.type == 'streammingexceededtrigger'){
                this.loading = false;
                this.isError = true;
                this.isExceeded = true;
            }else if(res.type == 'deviceonlinestatus'){
              if(res.data.deviceId == this.deviceId &&  res.data.isonline){
                  this.onStart();
                this.isStart = true;
              }else{
                this.loading = false;
                this.isError = true;
                this.isOffline = true;
              }
            }
          });
      }else{
        switch(res.message){
          case "Password required":
            this.requirePassword = true;
          break;
          case "Share not found":
            this.isError = true;
            this.isSharedDataAvaliableBox = true;
          break;
          case "Share expired":
            this.isError = true;
            this.isSharedExpired = true;
            this.expiryDate = res.expiryDate;
          break;
        }
      }
    }


    onResponseStream(res){
       let that = this;
      if(res.data && res.data.status){
        this.data = {};
        this.data.device = this.deviceId;
        this.data.videoUrl = "."+this._envService.envSpecific.streamURL+"/play.html?token="+res.data.videoplay;
        this.data.conference = {};
        this.data.playlive = {};
        this.data.isconference = true;
        this.data.conference.streamId = this.deviceId+res.data.username;
        this.data.conference.token = {
          publish: res.data.publish,
          play: res.data.play,
          videoplay: res.data.videoplay
        }
        
        this.data.conference.started = new Date(res.data.start);
        this.data.conference.livetimerInterval =  window.setInterval(function () {
            var today:any = new Date();
            var  caldate:any = (today - that.data.conference.started) / 1000;
            var convertDate = parseInt(caldate).toString();
            that.data.conference.livetimer = that.toHHMMSS(convertDate);

            if(that.data.conference!=null && that.data.conference.webRTCAdaptor != null){
              if(that.data.conference.isMicMute == true){
                that.data.conference.webRTCAdaptor.muteLocalMic();
              }else{
                that.data.conference.webRTCAdaptor.unmuteLocalMic();
              }
            }

            if(that.data.conference!=null && that.data.conference.volume != null){
              $(".audio"+that.data.device).prop("volume", that.data.conference.volume/100);
            }
          }, 1000);

        this.data.playing = true;
        this.data.livetimeout = setTimeout(() => {
        if(this.data.playing){
            if((new Date()) >=  this.data.conference.started.setMinutes(this.data.conference.started.getMinutes()+this.videoTimeout-1)){
              this._toastr.warning("Video streaming session timeout limit reached (6 hours).");
              this.onStop();
            }
          }
        }, this.videoTimeout * 60 * 1000);

        this.data.conference.volume = 0;
        this.onStartConference(this.data);
        setTimeout(() => {
          this.loading = false;
          this.isReady = true;
        }, 5000);
      }else{ 
        this.data = {};
        this.data.playing = false;
        this.data.iframe = null;
        this._toastr.error("Unable to start live streaming! "+res.data.deviceId + " device is not ready.");
      }
    }

    onStart(){
      this.publicSharedLiveService.RequestStartStreaming();
    }

    onStop(){
      this.data.playing = false;
      this.isError = true;
      this.isDisconnected = true;
      this.publicSharedLiveService.RequestStopStreaming();
      this.publicSharedLiveService.LiveviewDisconnect();
    }

    onStartConference(device){
      var that = this;
      device.conference.isPlaying =false;
      device.conference.remoteVideos=[];
      device.conference.webRTCAdaptor = new WebRTCAdaptor(	
        {
          websocket_url : this._envService.envSpecific.conferenceUrl + "/websocket",
          mediaConstraints : {
            video : false,
            audio : true
          },
          localVideoId : "local"+device.device,
          peerconnection_config : {
            'iceServers' : [ {
              'urls' :  this._envService.envSpecific.iceURL
            }]
          },
          isPlayMode : false,
          onlyDataChannel: false,
          debug : false,
          dataChannelEnabled : false,
          callback : (info, obj) => {
            if (info == "initialized") 
            {
              console.log("initialized");
              device.conference.webRTCAdaptor.publish(device.conference.streamId, device.conference.token.publish, "", "",  device.conference.streamId,device.device,"{someKey:someValue}");
              setTimeout(() => {
                device.conference.webRTCAdaptor.play(device.device, device.conference.token.play,device.device);
                device.conference.webRTCAdaptor.muteLocalMic();
                device.conference.isMicMute = true;
              }, 500);
            } 
            else if (info == "publish_started") {
    
            }
            else if(info == "roomInformation"){
              if(!device.conference.isPlaying  && obj.streams.length > 0) {
                var tempList = obj.streams;
                tempList.push("!"+device.conference.streamId);	
                device.conference.isPlaying = true;
              }
            }
            else if (info == "newTrackAvailable" || info == "newStreamAvailable") 
            {
              this.playVideo(obj,device);
            } 
            else if (info == "leavedFromRoom") 
            {
              console.log("leavedFromRoom");
              this.onLeaveConference(device)
            }
          },
          callbackError : function(error, message) {
            console.log(error);
          }
        });
  
      
      device.playlive.webRTCAdaptor = new WebRTCAdaptor({
          websocket_url : this._envService.envSpecific.conferenceUrl + "/websocket",
          isPlayMode: true,
          callback: function (info, obj) {
              if (info === "initialized") {
                  device.playlive.webRTCAdaptor.play("live_"+device.device,  device.conference.token.videoplay, "", [], "live_"+device.device, "");
              }
              else if (info == "newTrackAvailable") {
                that.playAntVideo(obj,device);
              }
          },
          callbackError: function (error) {
  
              console.log("error callback: " + JSON.stringify(error));
          }
      });
      
    }


    playVideo(obj,device) {
      var room = device.device;
      if (obj.trackId.indexOf("ARDAMSv") > -1) {
      }else{
        if (obj.trackId.indexOf("ARDAMSa") > -1) {
          var index = obj.trackId.replace("ARDAMSaaudioTrack", "");
          if(device.conference.remoteVideos.filter(q=>q==room+'remoteVideo'+index).length < 1){
            device.conference.remoteVideos.push(room+"remoteVideo"+index);
          }
          setTimeout(() => {
            var video = document.getElementById(room+"remoteVideo"+index);
            try{
              video.srcObject = new MediaStream();	
              video.srcObject.addTrack(obj.track)
              obj.track.onended = event => {
                // this.removeRemoteVideo(device.conference.remoteVideos,room+"remoteVideo"+index);
                video.srcObject.removeTrack(event.currentTarget);
              };
            }catch{}
            setTimeout(() => {
              $(".audio"+device.device).prop("volume", device.conference.volume  / 100);
              if(device.conference.volume > 0){
                this.playPauseAudio(true,device.device);
              }else{
                 this.playPauseAudio(false,device.device);
              }
            }, 100);
          }, 100);
        }
      }
    }

    playAntVideo(obj,device) {
        if (obj.track.kind === "video") 
        {
            device.conference.ready = true;
            var player = document.getElementById("video" + device.device);
            player.srcObject = new MediaStream();
            player.srcObject.addTrack(obj.track);
            player.removeAttribute('controls');
        }
    }

    onLeaveConference(device){
      //this._liveViewServices.RequestStopConference(device.device);
      if(device.conference.webRTCAdaptor != null){
        device.conference.webRTCAdaptor.stop(device.conference.streamId);
        device.conference.webRTCAdaptor.stop(device.device);
        device.conference.webRTCAdaptor.leaveFromRoom(device.device);
      }
      device.conference.webRTCAdaptor = null;
      device.conference.isPlaying =false;

      if(device.conference.livetimerInterval){
        clearInterval(device.conference.livetimerInterval);
      }

      if(device.playlive.webRTCAdaptor != null){
        device.playlive.webRTCAdaptor.stop("live_"+device.device);
      }

      this.localVideos = this.localVideos.filter(q=>q!="local"+device.device);

      device.conference = null;
    }

    submitPassword(formData:any, isValid:boolean) {

      this.submitted = true;

      if(!isValid) {
        return;
      }

      this.publicSharedService.passwordForm = {
        password: formData.password,
        require_password: true
      }

      this.loading = true;
      this.loadingMessage = "Processing...";
      this.publicSharedService.GetSharedLiveView(this.token,this.publicSharedService.passwordForm).subscribe(res => { 
        this.loading = false;
        if(res.status){
          this.requirePassword = false;
          this.LoadData(res);
        }else{
          if(res.message == 'Invalid password'){
            this._toastr.error("Incorrect pin code! Please try again.");
          }else{
            this._toastr.error("Unable to validate pin code! An unexpected error has occurred.");
          }
        }
      });
    }

    toHHMMSS(value) {
      var sec_num = parseInt(value, 10);
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      var seconds = sec_num - (hours * 3600) - (minutes * 60);
      var chours = hours.toString();
      var cminutes = minutes.toString();
      var cseconds = seconds.toString();
      if (hours < 10) { chours = "0" + hours.toString(); }
      if (minutes < 10) { cminutes = "0" + minutes.toString(); }
      if (seconds < 10) { cseconds = "0" + seconds.toString(); }
      return chours + ':' + cminutes + ':' + cseconds;
    }

  switchMic(device) {
    if(!device || !device.conference || !device.conference.webRTCAdaptor) {
      return;
    }

    try {
      if(device.conference.isMicMute) {
        // Turning Mic ON (enable two-way audio)
        device.conference.webRTCAdaptor.unmuteLocalMic();
        device.conference.isMicMute = false;

        // Auto unmute speaker + set volume to max
        device.conference.volume = 100;
        $(".audio" + device.device).prop("volume", 1);
        this.playPauseAudio(true, device.device);
      } else {
        // Turning Mic OFF (disabled two-way audio)
        device.conference.webRTCAdaptor.muteLocalMic();
        device.conference.isMicMute = true;
      }
    } catch (err) {
      console.error("switchMic error:", err);
    }
  }

  volumeUpdate(row){
     if(row.conference.volume > 0){
      this.playPauseAudio(true,row.device);
    }else{
      this.playPauseAudio(false,row.device);
    }
    $(".audio"+row.device).prop("volume", row.conference.volume/100)
  }

  volumeOnOff(row){
    if(row.conference.volume > 0){
      $(".audio"+row.device).prop("volume", 0);
      this.playPauseAudio(false,row.device);
      row.conference.volume = 0;
    }else{
      $(".audio"+row.device).prop("volume", 1);
          this.playPauseAudio(true,row.device);
      row.conference.volume = 100;
    }
  }

  zoomConference(row) {
    const doc: any = document;
    const fsElement = doc.fullscreenElement || doc.webkitFullscreenElement || doc.webkitCurrentFullScreenElement;

    if (!fsElement) {
      const videoEl = document.getElementById("video" + row.device) || document.getElementById("livevideo");
      this.fullScreen(videoEl);
    } else {
      // exiting fullscreen
      if (doc.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.webkitExitFullscreen) {
        doc.webkitExitFullscreen();
      } else if (fsElement.webkitExitFullscreen) {
        fsElement.webkitExitFullscreen();
      }
    }
  }

  numberOnly(event): boolean {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false;
      }
      return true;
  }
  
  generateRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }

  playPauseAudio(isplay,device){
     $(".audio"+device).each(function(index,media){ 
        if(isplay){
          media.play();
        }else{
          media.pause();
        }
      });
  }

  fullScreen(element) {
    // 1) Standard Fullscreen API (Chrome, Firefox, Edge, Safari macOS)
    if (element.requestFullscreen) {
      element.requestFullscreen().catch(err => console.warn('requestFullscreen failed:', err));
      return;
    }

    // 2) Older WebKit (Safari macOS old)
    if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
      return;
    }

    // 3) Safari iOS — only use <video>
    const video: any = element.tagName === 'VIDEO' ? element : element.querySelector('video');

    if (video && typeof video.webkitEnterFullscreen === 'function') {
      if (video.readyState >= 1) {
        video.webkitEnterFullscreen();
      } else {
        video.addEventListener('loadedmetadata', () => {
          video.webkitEnterFullscreen();
        }, { once: true });
      }
      return;
    }

    this._toastr.warning('Fullscreen is not supported in this browser.');
  }

}
